import { Component, OnInit } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../store';
import { SET_EDITOR_TYPE, ADD_TERRAIN, SET_ACTIVE_TERRAIN, MAP_DIFFICULTY_CHANGED, MAP_NAME_CHANGED, MAP_CODE_ENTERED, ENABLE_TERRAIN_EDITOR, DISABLE_TERRAIN_EDITOR } from '../actions';
import { TileType } from '../tile';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css']
})
export class PanelComponent implements OnInit {
  @select() hoverTile;
  @select() editorType;
  @select() mapName;
  @select() mapDifficulty;
  @select() map;
  @select() terrainEditorEnabled;
  @select() terrains;
  @select() activeTerrain;
  @select() terrainStatistics;
  @select() neighbours;

  store = null;
  _mapName: string = '';
  _map: string[][];
  _mapCode: string;
  _difficulty: string;
  newTerrainName: string = '';

  constructor(private ngRedux: NgRedux<IAppState>) {
    this.store = ngRedux;
    this.map.subscribe(s => {
      this._map = this.condenseMap(s);
      this.updateMap();
    });
    this.mapName.subscribe(s => {
      this._mapName = s;
      this.updateMap();
    });
    this.mapDifficulty.subscribe(s => {
      this._difficulty = s;
      this.updateMap();
    });
  }

  updateMap() {
    this._mapCode = JSON.stringify({
      name: this._mapName,
      difficulty: this._difficulty,
      tiles: this._map
    }, null, 2);
  }

  condenseMap(map) {
    let m = JSON.parse(JSON.stringify(map));
    let size = (axis) => axis == 'x' ? m[0].length : m.length;

    // top/bottom
    while (m[0] && m[0].every(v => !v || !v.type)) {
      m.shift();
    }

    while (m[size('y') - 1] && m[size('y') - 1].every(v => !v || !v.type)) {
      m.pop();
    }

    // left/right
    let hasLeftToClean = false;
    let hasRightToClean = false;

    do {
      let left = [];
      let right = [];
      m.forEach(row => {
        left.push(row[0]);
        right.push(row[size('x') - 1]);
      });

      hasLeftToClean = left.length && left.every(v => !v || !v.type);
      hasRightToClean = right.length && right.every(v => !v || !v.type);

      if (hasLeftToClean) {
        m.forEach(row => row.shift());
      }
      if (hasRightToClean) {
        m.forEach(row => row.pop());
      }
    } while (hasLeftToClean || hasRightToClean);

    return m;
  }

  ngOnInit() {
  }

  save() {
    var blob = new Blob([this._mapCode], {type: "application/json;charset=utf-8"});
    FileSaver.saveAs(blob, "map-" + this._mapName + ".json");
  }

  addTerrain() {
    this.ngRedux.dispatch({
      type: ADD_TERRAIN,
      payload: {
        name: this.newTerrainName
      }
    });

    this.setActiveTerrain(this.newTerrainName);

    this.newTerrainName = '';
  }

  setActiveTerrain(terrain) {
    this.ngRedux.dispatch({
      type: SET_ACTIVE_TERRAIN,
      payload: {
        terrain: terrain
      }
    });

    this.newTerrainName = '';
  }
  
  onMapCodeChange(event: any) {
    this.ngRedux.dispatch({
      type: MAP_CODE_ENTERED,
      payload: {
        code: JSON.parse(event.target.value)
      }
    });
  }

  enableTerrainEditor() {
    this.ngRedux.dispatch({
      type: ENABLE_TERRAIN_EDITOR
    });
  }

  disableTerrainEditor() {
    this.ngRedux.dispatch({
      type: DISABLE_TERRAIN_EDITOR
    });
  }

  mapNameChanged(event: any) {
    this.ngRedux.dispatch({
      type: MAP_NAME_CHANGED,
      payload: {
        name: event.target.value
      }
    });
  }

  mapDifficultyChanged(event: any) {
    this.ngRedux.dispatch({
      type: MAP_DIFFICULTY_CHANGED,
      payload: {
        difficulty: event.target.value
      }
    });
  }

  setEditorType(type: TileType) {
    this.ngRedux.dispatch({
      type: SET_EDITOR_TYPE,
      payload: {
        type: type
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/panel/panel.component.ts